import { useState } from "react";

export function useToggle(): [boolean, () => void] {
  const [toggle, setToggle] = useState(false);

  const handleOnToggle = () => {
    setToggle(!toggle);
  };

  return [toggle, handleOnToggle];
}
